import { useCallback, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import { getReportMerchants, searchReportMerchants } from 'api/merchant'
import { DropDownItem } from 'types/components'

import { QUERY_KEYS } from 'constants/querykeys'

export const useReportMerchantsQuery = () => {
  const queryKey = [QUERY_KEYS.REPORT_MERCHANT_LIST]
  const queryFn = async () => {
    return await getReportMerchants()
  }
  const queryOptions = {
    refetchOnWindowFocus: false,
    queryKey,
    queryFn,
  }
  const query = useQuery(queryOptions)

  const reportMerchantOptions = query.data
    ? query.data.map((item) => ({
        label: item.merchantName,
        value: String(item.traderId),
      }))
    : []

  return {
    query,
  }
}

export const useReportMerchantsMutation = () => {
  const queryClient = useQueryClient()

  const { mutateAsync } = useMutation({
    mutationFn: searchReportMerchants,
    mutationKey: [QUERY_KEYS.REPORT_MERCHANT_SEARCH],
    onMutate: () => {
      // console.log('loading ...')
    },
    onSuccess: () => {
      // console.log('success')
    },
    onError: () => {
      // console.log('error')
    },
  })

  const onSearchMerchantsLoader = useCallback(
    async (inputValue: string) => {
      if (inputValue.length < 3) return []
      const data = await mutateAsync(inputValue)
      const options = data.map((item) => ({
        label: String(item.merchantName),
        value: String(item.traderId),
      }))
      return options
    },
    [mutateAsync]
  )

  return {
    onSearchMerchantsLoader,
  }
}

export const useReportMerchantsSelectQuery = () => {
  const [selectedMerchants, selectedMerchantsSet] = useState<DropDownItem[]>([])

  const onSelectMerchants = useCallback(
    (merchant: DropDownItem) => {
      if (!merchant) return
      const isExist = selectedMerchants.find(
        (item) => item.value === merchant?.value
      )
      if (!isExist) selectedMerchantsSet([...selectedMerchants, merchant])
      if (isExist)
        selectedMerchantsSet(
          selectedMerchants.filter((item) => item.value !== merchant.value)
        )
    },
    [selectedMerchants, selectedMerchantsSet]
  )

  return {
    selectedMerchants,
    onSelectMerchants,
  }
}
